import React, { useRef, useState, useEffect } from "react";
import Loader from "../component/loader";
import { Player, ControlBar, PlayToggle } from "video-react";
import AddFileIcon from "../icons/plusicon";
import CopyIcon from "../icons/copyicon";
import DeletefileIcon from "../icons/DeletefileIcon";

export default function VideoOnlyUpload({
  insideOnchange,
  videoPreLoader,
  handleVideo,
  iconDelete,
  deleteVideo,
  showDeleteIcon,
  videoUrl,
  video,
  uploadmessage
}) {
  const ref = useRef(null);
  return (
    <>
      <span className="form_note">{uploadmessage}</span>
      <input
        name="homeVideo"
        id="myInput"
        type="file"
        ref={ref}
        style={{ display: "none" }}
        onChange={(e) => handleVideo(e, ref)}
        className="file-upload"
        // accept=".mp4"
        accept={".png, .jpg, .jpeg, .mp4"}
      />
      <div className="form_group_video_wpr absolute_loader">
        {videoPreLoader ? (
          <Loader />
        ) : (
          <>
            <Player
              playsInline
              autoPlay={false}
              type="video/mp4"
                src={video}
                // poster="/images/image-placeholder.png"
              // src="https://www.w3schools.com/html/mo  v_bbb.mp4"
              >
                <ControlBar autoHide={false} disableDefaultControls={true}>
                  <PlayToggle />
                </ControlBar>
              </Player>
            </>
          )}
        <div className={`input_file  file_upload ${showDeleteIcon ? `active` : ``}`}>
          <span
            className="pointer"
            onClick={() => {
              ref.current.click();
            }}
          >
            <AddFileIcon />
          </span>
        </div>
        {showDeleteIcon && iconDelete &&
          <span className="remove_file pointer  "
            onClick={deleteVideo}
          ><DeletefileIcon /></span>
        }
      </div>
      <div className="field_row">
        <div className="field_input relative">
          <input
            type="text"
            placeholder="https://cloudfront.aws.com/sdf2345"
            name="link"
            value={videoUrl}
            onChange={insideOnchange}
          />
          <span className="copy_box pointer_auto">
            <CopyIcon />
          </span>
        </div>
      </div>
    </>
  );
}
